import React, { useState } from 'react';
import InventarioPinModal from '../cantina/productos/InventarioPinModal';

// Muestra quién está operando y deja identificarse o cambiar de operador.
export default function BarraOperador({ operador, onIdentificar }) {
  const [abierto, setAbierto] = useState(false);

  return (
    <>
      <div className="flex items-center gap-3 rounded-xl border border-gray-200 bg-white px-4 py-2 text-sm shadow-sm">
        <span className="text-gray-500">Operando:</span>

        {operador ? (
          <strong className="text-azul-oscuro">
            {operador.nombre || `Usuario ${operador.id}`}
          </strong>
        ) : (
          <span className="font-semibold text-amber-700">
            sin identificar (se pedirá el PIN al operar)
          </span>
        )}

        <button
          type="button"
          onClick={() => setAbierto(true)}
          className="ml-auto rounded-lg border border-azul-lago px-3 py-1 text-xs font-bold text-azul-lago transition hover:bg-azul-lago hover:text-white"
        >
          {operador ? 'Cambiar' : 'Identificarme'}
        </button>
      </div>

      <InventarioPinModal
        abierto={abierto}
        titulo={operador ? 'Cambiar de operador' : 'Identificarse'}
        descripcion="Ingresá tu PIN para operar en Restaurante"
        onClose={() => setAbierto(false)}
        onConfirm={(usuario) => {
          onIdentificar(usuario);
          setAbierto(false);
        }}
      />
    </>
  );
}
